/**
 * GoldFire Network (https://goldfire.me)
 * Copyright (c) 2012 - 2020, GoldFire Studios, Inc.
 * http://goldfirestudios.com
 */

// Handle the development environment variables.
let Dev;
if (process.env.NODE_ENV === 'development' && typeof windows === 'undefined') {
  Dev = require('../../bin/development');
}

/**
 * The default state of the application.
 */
export function createState() {
  return {
    app: {
      type: null,
      steam: {
        id: '',
        lang: '',
        appId: '',
      },
    },
    now: Date.now(),
    user: {
      auth: false,
      user: '',
      uid: '',
      avatar: '',
      games: [],
      notices: true,
      email: '',
      emailcheck: false,
      guest: false,
      isGdpr: false,
      gdpr: null,
      ltv: 0,
      forumban: false,
      ua: typeof window !== 'undefined' ? window.navigator.userAgent : '',
      verify: 0,
    },
    auth: {
      email: '',
      pass: '',
      emailTaken: false,
      activeView: 'login',
      showLogin: false,
      showVerify: false,
      showTerms: false,
    },
    status: {
      players: {},
    },
    activeGame: {},
    updates: {
      show: false,
      reviews: false,
      all: true,
      data: [],
    },
    notices: [],
    toolbar: {
      activeTab: 'empty',
      transition: 'slide',
      topTabs: ['launcher', 'chat', 'forums', 'leaderboards', 'shop'],
      bottomTabs: ['info', 'fullscreen'],
      sound: null,
      left: false,
    },
    panel: {
      history: [],
      title: '',
      buttons: [],
      input: {
        placeholder: '',
        value: '',
        show: false,
      },
      status: null,
      altStatus: null,
      altIcon: null,
      altMethod: {},
      wide: false,
      scrollStart: true,
      scrollEnd: false,
      scrollTop: 0,
      scrollToBottom: false,
      loading: false,
      footerView: null,
      headerView: null,
      buttonTransition: null,
      updateScroll: false,
    },
    launcher: {
      counter: 0,
      defaultView: 'launcher-view',
      activeView: 'launcher-view',
      games: [],
      notificationsId: 0,
      notifications: [],
      profile: {},
      hideIframe: false,
    },
    chat: {
      counter: 0,
      defaultView: 'chat-list-view',
      activeView: 'chat-list-view',
      friendListType: 'friend',
      friendListExclude: [],
      activeMessage: {
        name: null,
        user: '',
        uid: '',
        id: '',
        ignore: false,
        messages: [],
        players: [],
      },
      settings: {
        players: [],
      },
      messages: [],
    },
    friends: {
      defaultView: 'friends-view',
      activeView: 'friends-view',
      players: [],
      cache: {},
    },
    forums: {
      counter: 0,
      defaultView: 'forums-view',
      activeView: 'forums-view',
      currentCategory: 0,
      filteredTags: [],
      searchIsVisible: false,
      searchQuery: '',
      tags: {
        show: false,
        filter: false,
        select: false,
        names: [
          'Off-Topic',
          'Entertainment',
          'Gaming',
          'News',
          'Sports',
          'Help',
          'General',
          'Strategy',
          'Events',
          'Bugs/Ideas',
          'Thoughts',
        ],
      },
      categories: [
        {
          name: 'General',
          id: 'general',
          gid: 0,
          unread: 0,
          active: true,
          tags: {
            'Off-Topic': 'green',
            Entertainment: 'purple',
            Gaming: 'red',
            News: 'black',
            Sports: 'aqua',
            Help: 'yellow',
          },
        },
        {
          name: 'CasinoRPG',
          id: 'casinorpg',
          gid: 3,
          unread: 0,
          active: true,
          tags: {
            General: 'green',
            Strategy: 'red',
            Events: 'purple',
            'Bugs/Ideas': 'black',
            Help: 'yellow',
            Thoughts: 'aqua',
          },
        },
        {
          name: 'BC Wars',
          id: 'bcwars',
          gid: 1,
          unread: 0,
          active: true,
          tags: {
            General: 'green',
            Strategy: 'red',
            Events: 'purple',
            'Bugs/Ideas': 'black',
            Help: 'yellow',
          },
        },
        {
          name: 'PokerRPG',
          id: 'pokerrpg',
          gid: 2,
          unread: 0,
          active: true,
          tags: {
            General: 'green',
            Strategy: 'red',
            Events: 'purple',
            'Bugs/Ideas': 'black',
            Help: 'yellow',
          },
        },
        {
          name: 'Exocraft',
          id: 'exocraft',
          gid: 4,
          unread: 0,
          active: true,
          tags: {
            General: 'green',
            Strategy: 'red',
            Events: 'purple',
            'Bugs/Ideas': 'black',
            Help: 'yellow',
          },
        },
      ],
      threads: [],
      threadsToLoad: [],
      activeThread: {
        id: null,
        locked: false,
        posts: [],
        poll: null,
        postCount: 0,
        title: '',
      },
      notifications: 0,
      reload: false,
      end: false,
      page: null,
    },
    leaderboards: {
      defaultView: 'leaderboards-view',
      activeView: 'leaderboards-view',
      activeCategory: {},
      categories: [],
      players: [],
      allTime: true,
      allUsers: true,
      uid: null,
      user: '',
      gid: 0,
      medals: [],
    },
    shop: {
      cart: [],
      error: {},
      defaultView: 'shop-view',
      activeView: 'shop-view',
      gift: '',
      paypal: false,
      xsolla: null,
      history: [],
      manage: {
        cards: [],
        subs: [],
      },
    },
    info: {
      defaultView: 'info-view',
      activeView: 'info-view',
      // apps: ['windows', 'chrome', 'steam', 'apple', 'android', 'amazon'],
      online: [],
    },
    editor: {
      show: false,
      emoji: false,
      media: false,
      enterDown: false,
      reset: false,
      hasPoll: false,
      poll: {},
      view: 'editor',
      type: '',
      value: '',
      initialValue: '',
      title: '',
      selectedTags: [],
      prevButtons: [],
      titleError: false,
    },
    socialFeed: {
      activeView: 'social-feed-view',
      updates: [],
      counter: 0,
      updateCount: 0,
    },
    settings: {
      verify: 0,
      email: '',
      loc: '',
      gender: '',
      pass: '',
      user: '',
      emails: true,
      notices: true,
      multiFactor: false,
      flags: {},
      error: {
        badEmail: false,
        passLen: false,
        emailTaken: false,
        badCountry: false,
        badUser: false,
        userTaken: false,
      },
      mute: false,
      left: false,
    },
    scroll: {
      start: true,
      end: false,
      direction: '',
      loading: false,
    },
    index: {
      friends: [],
    },
    directory: {
      players: [],
    },
    gameData: [
      {
        gid: 0,
        game: 'goldfire',
        title: 'GoldFire',
        online: 0,
        shop: [],
        appShop: [],
      },
      {
        gid: 3,
        game: 'casinorpg',
        title: 'CasinoRPG',
        descr: 'Play the tables or own the strip in this Vegas-themed MMORPG that merges role-playing, tycoon, city-building and your favorite casino games.',
        video: 'https://www.youtube.com/embed/aN2OtiIKW_0?autoplay=1',
        screens: ['000', '001', '002', '003', '004', '005'],
        url: {
          dev: Dev ? Dev.casinorpg.url : 'http://localhost:8888/game/',
          test: 'https://test.casinorpg.com',
          prod: 'https://play.casinorpg.com',
        },
        auth: 'http://casinorpg.com/auth/game',
        preload: {
          test: 'https://test.casinorpg.com/preload.html',
          prod: 'https://play.casinorpg.com/preload.html',
        },
        online: 0,
        appStorePrompt: {
          apple: 'https://itunes.apple.com/us/app/casinorpg-vegas-tycoon/id1254175032?ls=1&mt=8',
          google: 'https://play.google.com/store/apps/details?id=com.goldfirestudios.casinorpg',
        },
        apps: [
          {
            icon: 'apple',
            url: 'https://itunes.apple.com/us/app/casinorpg-vegas-tycoon/id1254175032?ls=1&mt=8',
          },
          {
            icon: 'android',
            url: 'https://play.google.com/store/apps/details?id=com.goldfirestudios.casinorpg',
          },
          {
            icon: 'steam',
            url: 'http://store.steampowered.com/app/658970/CasinoRPG/',
          },
          {
            icon: 'chrome',
            url: 'https://chrome.google.com/webstore/detail/casinorpg-poker-slots-tyc/dfadcimibgpdemlpghdofndlapaiciel',
          },
          {
            icon: 'windows',
            url: 'https://www.microsoft.com/en-us/store/p/casinorpg-online-casino/9wzdncrdlzx7',
          },
        ],
        dynamicUpdates: true,
        guide: 'https://guide.casinorpg.com/',
        feedback: true,
        guests: true,
        feedbackCat: '65070',
        leaderboards: true,
        ogImage: true,
        shop: [],
        appShop: [],
        orientation: 'landscape',
      },
      {
        gid: 1,
        game: 'bcwars',
        title: 'BC Wars',
        descr: 'Enter a prehistoric world where you can train/battle dinosaurs, build your cave, join a tribe and become a legend through time.',
        screens: ['001', '002', '003', '004', '005'],
        login: 'https://bcwars.com/login_goldfire.php',
        url: {
          dev: 'https://bcwars.com',
          test: 'https://bcwars.com',
          prod: 'https://bcwars.com',
        },
        online: 0,
        apps: [],
        updates: 'https://bcwars.com/news',
        feedback: true,
        leaderboards: false,
        scroll: true,
        shop: [],
        appShop: [],
        orientation: 'all',
      },
      {
        gid: 2,
        game: 'pokerrpg',
        title: 'PokerRPG',
        descr: 'Create your character and join up with friends to play poker, blackjack and more as you advance your worldwide career to be the best gambler.',
        screens: ['001', '002', '003', '004', '005'],
        login: 'https://pokerrpg.com/login_goldfire.php',
        url: {
          dev: 'http://local.pokerrpg.com',
          test: 'https://pokerrpg.com',
          prod: 'https://pokerrpg.com',
        },
        online: 0,
        apps: [],
        updates: 'https://pokerrpg.com/news',
        feedback: true,
        leaderboards: false,
        scroll: true,
        hidden: true,
        shop: [],
        appShop: [],
        orientation: 'all',
      },
      {
        gid: 4,
        game: 'exocraft',
        title: 'Exocraft.io',
        descr: 'Design unique ships and grow the ultimate space mining fleet as you battle for resources and glory in this massively multiplayer action strategy set in an alien wasteland.',
        bgVideo: true,
        video: 'https://www.youtube.com/embed/EZ-Jw5z61QE?autoplay=1',
        screens: ['000', '001', '002', '003', '004', '005', '006', '007', '008'],
        url: {
          dev: Dev && Dev.exocraft.url ? Dev.exocraft.url : 'http://localhost:7777',
          test: 'https://beta.exocraft.io',
          prod: 'https://game.exocraft.io',
        },
        online: 0,
        apps: [
          {
            icon: 'apple',
            url: 'https://itunes.apple.com/us/app/exocraft-space-ship-battles/id1460263762?ls=1&mt=8',
          },
          {
            icon: 'android',
            url: 'https://play.google.com/store/apps/details?id=com.goldfire.exocraft.io.space.battle.game',
          },
          {
            icon: 'steam',
            url: 'https://store.steampowered.com/app/793490/Exocraft/',
          },
          {
            icon: 'windows',
            url: 'https://www.microsoft.com/en-us/p/exocraftio-battle-build-space-ship-fleets/9ppsdqh8mtps',
          },
        ],
        dynamicUpdates: true,
        dynamicGuide: true,
        feedback: true,
        feedbackCat: '324265',
        leaderboards: true,
        noMobileScale: true,
        guests: true,
        ioGamesButton: true,
        addictingGames: true,
        ogImage: true,
        shop: [],
        appShop: [],
        orientation: 'landscape',
      },
    ],
  };
}
